import { render, staticRenderFns } from "./myContact.vue?vue&type=template&id=85aeb876&scoped=true"
import script from "./myContact.vue?vue&type=script&lang=js"
export * from "./myContact.vue?vue&type=script&lang=js"
import style0 from "./myContact.vue?vue&type=style&index=0&id=85aeb876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85aeb876",
  null
  
)

export default component.exports